import { matchSorter } from "match-sorter";

export enum ProjectSelectOptionType {
  All = "all",
  Project = "project"
}

export interface IProjectSelectOption {
  label: string;
  value: string;
  type: ProjectSelectOptionType;
}

export const filterOptions = (
  projects: Array<{ id: string; name: string }>,
  term: string
) => {
  // projects
  const matchedProjects = matchSorter<{ id: string; name: string }>(
    projects,
    term,
    {
      keys: ["name"]
    }
  );

  const options = [
    {
      label: "All projects",
      value: "all",
      type: ProjectSelectOptionType.All
    }
  ];

  return options.concat(
    matchedProjects.map(project => ({
      label: project.name,
      value: project.id,
      type: ProjectSelectOptionType.Project
    }))
  );
};
